<template>
  <section>
    <!-- Componentes externos -->
    <crear-actualizar-inamovilidad />
    
    <h3 class="primary--text">
      <v-icon color="primary">accessibility</v-icon>Inamovilidad
    </h3>
    <ver-documento />
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :data-graphql="dataGraphql"
          :graphql="graphql"
          :initData="initData"
        >
          <!-- Template injectable de la cabecera de la tabla -->
          <template slot="buttons">
            <v-tooltip bottom>
              <v-btn
              v-if="estado==1"
                color="primary"
                dark
                @click.native.stop="crearActualizarInamovilidad({})"
                slot="activator"
                ><v-icon dark>add</v-icon> {{ $t("common.add") }}</v-btn
              >
              <span>Agregar Inamovilidad</span>
            </v-tooltip>
          </template>

          <!-- Template de filas y columnas -->
          <template slot="items" slot-scope="items">
            <!-- Agregar las columnas que consideré necesarias -->
            <td class="text-xs-center">
              {{
                items.item.parametro_causal
                  ? items.item.parametro_causal.valor
                  : ""
              }}
            </td>

            <td class="text-xs-center">
              {{ $moment(items.item.fecha_inicio).format("DD/MM/YYYY") }}
            </td>
            <td class="text-xs-center">
              {{ $moment(items.item.fecha_fin).format("DD/MM/YYYY") }}
            </td>

            <td class="text-xs-center">
              <v-tooltip bottom v-if="estado==1 || rol!=42">
                <v-btn
                  color="primary"
                  icon
                  slot="activator"
                  @click.native="crearActualizarInamovilidad(items.item)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar registro</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  color="green"
                  v-if="items.item.url_documento.length > 0"
                  dark
                  icon
                  slot="activator"
                  @click.native="verDocumento(items.item)"
                >
                  <v-icon color="dark">visibility</v-icon>
                </v-btn>
                <span>Ver registro</span>
              </v-tooltip>
              <v-tooltip bottom v-if="estado==1">
                <v-btn
                  color="red"
                  dark
                  icon
                  slot="activator"
                  @click="deleteItem(items.item.id, 'inamovilidad')"
                >
                  <v-icon color="dark">delete</v-icon>
                </v-btn>
                <span>Eliminar registro</span>
              </v-tooltip>
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue"; // Componente Tabla Dinámica
import crud from "@/common/util/crud-table/mixins/crud-table"; // Funciones y Metodos
import CrearActualizarInamovilidad from "../dialogs/CrearActualizarInamovilidad"; // Componente de creación y actualización
import VerDocumento from "../dialogs/VerDocumento.vue";

export default {
  // Importación de métodos y funciones de un archivo mixin
  mixins: [crud],
  props: ["persona"],
  // Variables iniciales del componente
  data() {
    return {
      url: "inamovilidads",
      graphql: true,
      // Cabecera de la tabla
      headers: [
        // { text: 'Nombre de la cabecera', value: 'Campo que deseamos interpolar', align: 'center' },
        {
          text: "Capacidades Diferentes",
          value: "id_parametro_causal",
          align: "center"
        },
        { text: "Fecha Inicio", value: "fecha_inicio", align: "center" },
        { text: "Fecha Fin", value: "fecha_fin", align: "center" },
        { text: this.$t("common.actions"), sortable: false, align: "center" }
      ],
      // Campos solicitados de Graphql(Agregar los que necesite)
      dataGraphql: `
            id
        id_parametro_causal
        id_persona
        fecha_inicio
        fecha_fin
        url_documento
        id_estado
        parametro_causal{
          id
          valor
          }
        _user_created
        _user_updated
        _created_at
        _updated_at
      `,
      // Filtros del componente CrudTable ejemplo:
      // {
      // 	field: 'Campo definido en Graphql',
      // 	label: 'Etiqueta del input generado',
      // 	type: 'text', // Tipo de input en el filtro
      // 	typeG: 'String' // Tipo definido en Graphql
      // }
      filters: [],
      initData: [
        {
          state: true,
          param: "id_persona",
          value: this.persona.id
        }
      ],
      estado:[],
      rol:[]
    };
  },
  // Funcionalidades que se ejecutan al montar el componente
  mounted() {
    this.$bus.$on("verDocumento", item => {
      this.url = item;
      this.dialog = true;
    });
    // Verificando si el usuario tiene permiso para interactual con el componente
    const rolesPermitidos = [0]; // ID's de roles permitidos
    if (!this.$util.permisoRol(rolesPermitidos)) {
      this.$router.push("/403");
    }

    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
    this.obtenerEstadoFicha();
  },
  // Métodos y funciones del componente
  methods: {
    async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    },
    crearActualizarInamovilidad(item) {
      this.$bus.$emit("openDialogCrearActualizarInamovilidad", item);
    },
    async cambiarEstado(item) {
      let value = item.id_estado === "20" ? 1 : 20;
      let data = {
        id_estado: value
      };
      try {
        await this.$service.graphql({
          query: `
            mutation edit($id: ID!, $inamovilidad: EditInamovilidad!) {
              inamovilidadEdit(id: $id, inamovilidad: $inamovilidad) {
                id
              }
            }
          `,
          variables: {
            id: item.id,
            inamovilidad: data
          }
        });
        if (value === 1) {
          this.$message.success("Inamovilidad habilitado");
        } else {
          this.$message.warning("Inamovilidad deshabilitado");
        }
        this.updateList();
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
       this.rol=user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
          query{
                  vListafichas(id_persona:${user.id_persona}){
                    rows{
                      id_persona
                      nombre
                      nro_doc
                      id_estado_ficha
                      estado_ficha
                      habilitado
                      item
                      id_unidad
                      unidad      
                    }
                  }
                }
        `
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado=this.estados_ficha[0].habilitado
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
  },
  // Definición de componentes importados
  components: {
    CrudTable,
    CrearActualizarInamovilidad,
    VerDocumento
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/Inamovilidad.vue